import React from 'react';

import scss from './MediaCard.module.scss';

function Image({ src, alt, onClick }) {
  return (
    <img
      src={src}
      alt={alt}
      className={scss.image}
      role='presentation'
      loading='lazy'
      decoding='async'
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
    />
  );
}

export default Image;
